import { useEffect, memo, Fragment, useContext } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { ShepherdTour, ShepherdTourContext } from "react-shepherd";
import Headerpro from "../../components/partials/pro/headerstyle/header-pro";
import SubHeader from "../../components/partials/dashboard/headerstyle/sub-header";
import Sidebar from "../../components/partials/dashboard/sidebarstyle/sidebar";
import Footer from "../../components/partials/dashboard/footerstyle/footer";
import Loader from "../../components/Loader";
import * as SettingSelector from "../../store/setting/selectors";
import { useSelector } from "react-redux";
import { Suspense } from "react";

const Tour = () => {
  const tour = useContext(ShepherdTourContext);
  const { pathname } = useLocation();
  useEffect(() => {
    if (
      pathname === "/dashboard" &&
      sessionStorage.getItem("tour") !== "true"
    ) {
      tour?.start();
    }
  });
  return <Fragment></Fragment>;
};

const Default = memo((props) => {
  let location = useLocation();
  const pageLayout = useSelector(SettingSelector.page_layout);
  const appName = useSelector(SettingSelector.app_name);
  useEffect(() => {
    return () => {
      sessionStorage.setItem("tour", "true");
    };
  });

  const closeTour = () => {
    sessionStorage.setItem("tour", "true");
  };

  const newSteps = [
    {
      title: "<h4>Menu</h4>",
      text: '<p className="mb-0">Choose one of the available menu options to continue. Each option provides access to different features and settings.</p>',
      attachTo: { element: ".sidebar ", on: "right" },
      buttons: [
        {
          type: "next",
          text: "Next",
        },
      ],
      when: {
        show: () => {
          document
            .querySelector(".shepherd-modal-overlay-container")
            .classList.add("shepherd-modal-is-visible");
        },
        cancel: () => closeTour(),
      },
    },
    {
      title: "<h4>Profile Setting</h4>",
      text: '<p className="mb-0">Configure your Profile using Profile Settings. Edit, save and update your profile from here.</p>',
      attachTo: { element: ".iq-tour ", on: "bottom" },
      buttons: [
        {
          type: "back",
          classes: "shepherd-button-secondary",
          text: "Back",
        },
        {
          action() {
            sessionStorage.setItem("tour", "true");
            return this.next();
          },
          text: "Done",
        },
      ],
      when: {
        cancel: () => closeTour(),
      },
    },
  ];
  const tourOptions = {
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
    },
    when: {
      cancel: function () {},
    },
  };
  var subHeader = "";
  var commanclass = "";
  switch (location.pathname) {
    case "/dashboard/special-pages/calender":
    case "/dashboard/special-pages/billing":
    case "/dashboard/special-pages/kanban":
    case "/dashboard/special-pages/pricing":
    case "/dashboard/special-pages/timeline":
    case "/dashboard/table/table-data":
    case "/dashboard/table/bootstrap-table":
    case "/dashboard/table/border-table":
    case "/dashboard/table/fancy-table":
    case "/dashboard/table/fixed-table":
    case "/dashboard/app/user-list":
    case "/dashboard/icon/solid":
    case "/dashboard/icon/outline":
    case "/dashboard/icon/dual-tone":
      subHeader = <SubHeader />;
      commanclass = "iq-banner default";
      break;
    default:
      break;
  }

  return (
    <Fragment>
      <ShepherdTour steps={newSteps} tourOptions={tourOptions}>
        <Loader />
        <Sidebar app_name={appName} />
        <Tour />
        <main className="main-content">
          <div className={`${commanclass} position-relative `}>
            <Headerpro />
            {subHeader}
          </div>
          <div className={` ${pageLayout} content-inner pb-0`}>
            <Suspense fallback={<div className="react-load"></div>}>
              <Outlet></Outlet>
            </Suspense>
          </div>

          <Footer />
        </main>
      </ShepherdTour>
    </Fragment>
  );
});

Default.displayName = "Default";
export default Default;
